export enum VideoCaptureScreen {
  PERMISSIONS = 'permissions',
  TUTORIAL = 'tutorial',
  CAPTURE = 'capture',
  GALLERY = 'gallery',
  VEHICLE_SELECTION = 'vehicle-selection',
  PHOTO_CAPTURE = 'photo-capture',
}
